import PropTypes from 'prop-types'

export default function GreenToggle({
  id,
  type,
  children,
  onChange,
  active,
  disabled,
  helpText,
  hidden,
  inputProps,
}) {
  return (
    <label
      title={helpText}
      className={`tw-flex tw-relative tw-items-center tw-mb-0 tw-text-system-grey-900 tw-truncate ${
        disabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'
      }`}
      htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        className="tw-absolute tw-opacity-0 tw-w-0 tw-h-0"
        onChange={onChange}
        checked={!!active}
        disabled={!!disabled}
        {...inputProps}
      />
      <CustomToggle active={active} disabled={disabled} hidden={hidden}>
        {children}
      </CustomToggle>
    </label>
  )
}

GreenToggle.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  active: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'toggle', 'green']),
  helpText: PropTypes.string,
  hidden: PropTypes.bool,
  inputProps: PropTypes.object,
}

export function CustomToggle({ active, disabled, children }) {
  return (
    <>
      <div className={'tw-block tw-group tw-relative'}>
        <div
          className={`
        tw-w-16
        tw-h-8
        tw-rounded
        tw-shadow-inner 
        tw-border 
        tw-border-solid 
        tw-transition-all 
        tw-duration-300 
        tw-ease-in-out 
        tw-bg-white
        ${
          active
            ? 'tw-border-success-900'
            : `tw-border-system-grey-200 ${
                !disabled ? 'group-hover:tw-border-system-grey-300' : ''
              }`
        }
        `}></div>
        <div
          className={`
        tw-absolute 
        tw-w-7
        tw-h-6
        tw-rounded
        tw-shadow 
        tw-inset-0
        tw-m-1
        tw-transition-all 
        tw-duration-300 
        tw-ease-in-out 
        tw-flex
        tw-items-center
        tw-justify-center
        ${
          active
            ? 'tw-bg-success-900 tw-custom-translate-x-full'
            : `tw-bg-system-grey-200 ${
                !disabled ? 'group-hover:tw-bg-system-grey-300' : ''
              }`
        }
        `}>
          <svg
            className={`tw-transition-all tw-duration-100 tw-ease-linear ${
              active ? '' : 'tw-hidden'
            }`}
            width="13"
            height="10"
            viewBox="0 0 13 10"
            fill="none">
            <path
              d="M1 5.88889L4.08 9L12 1"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
      {children && (
        <span
          className={`tw-ml-3 ${disabled ? 'tw-text-system-grey-400' : ''}`}>
          {children}
        </span>
      )}
    </>
  )
}

CustomToggle.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
}
